export class SmpUtils {

    // For a string enum, this method will only return an empty array,
    // since it does not contain numbers like a regular enum
    public static enumToArray(stringEnum: any): number[] {
        const enumAsArray = [];

        if (stringEnum) {
            for (const i in stringEnum) {
                if (typeof stringEnum[i] === 'number') {
                    enumAsArray.push(stringEnum[i]);
                }
            }
        }

        return enumAsArray;
    }

    // Works for both regular and string enums
    // Returns an array of the strings
    public static enumToStringArray(daEnum: any): string[] {
        const enumAsArray = [];

        if (daEnum) {
            for (const i in daEnum) {
                if (typeof daEnum[i] === 'string') {
                    enumAsArray.push(daEnum[i]);
                }
            }
        }

        return enumAsArray;
    }

    public static validateAsEmail(input: string): boolean {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(input).toLowerCase());
    }

    public static getExtensionFromFileName(name: string): string {
        name = typeof name === 'string' ? name.toLowerCase() : name;
        const re = /(?:\.([^.]+))?$/;
        return re.exec(name)[1];
    }

    public static passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!?(){}\\[\\]\\\\\\/=~+,@#\\$%\\^&_.\\-\\*])(?=.{8,})';

    public static hasUpperChar(text: string): boolean {
        return this.regexCheck(text, '(?=.*[A-Z])');
    }

    public static hasLowerChar(text: string): boolean {
        return this.regexCheck(text, '(?=.*[a-z])');
    }

    public static hasNumberChar(text: string): boolean {
        return this.regexCheck(text, '(?=.*[0-9])');
    }

    public static hasSpecialChar(text: string): boolean {
        return this.regexCheck(text, '(?=.*[!?(){}\\[\\]\\\\\\/=~+,@#\\$%\\^&_.\\-\\*])');
    }

    public static hasLength(text: string, length: number): boolean {
        const lengthCheck = `(?=.{${length},})`;
        return this.regexCheck(text, lengthCheck);
    }

    public static toTitleCase(text: string): string {
        return text.replace(/\b\w+/g, (word: string) => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
    }

    private static regexCheck(text: string, regexString: string): boolean {
        const regex = new RegExp(regexString);
        return regex.test(text);
    }

}

declare global {
    interface String {
        toTitleCase(): String;
    }
}

String.prototype.toTitleCase = function(): String {
    return SmpUtils.toTitleCase(this);
}